import React from 'react'
import moment from 'moment'
import { humanizeDate } from 'utils/datetime'

const PlanRenewal = ({ isAnnual, addons, billing }) => {
  const ADDON_CONFIG = {
    additionalPublishedApps: 'additional published apps',
    additionalTeamMembers: 'additional app editor seats',
  }

  const { nextBill, nextBillDate } = billing
  const formattedNextBill = nextBill.toLocaleString('en-US')

  const renewalText = `Your plan subscription is billed ${
    isAnnual ? 'yearly' : 'monthly'
  } and will automatically renew for $${formattedNextBill} on ${nextBillDate}`

  const activeAddons = Object.entries(ADDON_CONFIG)
    .filter(([key]) => addons[key] > 0)
    .map(([, text]) => text)

  let addonDescription = null
  if (activeAddons.length > 0) {
    const listFormatter = new Intl.ListFormat('en')
    const addons = listFormatter.format(activeAddons)
    const renewalDate = humanizeDate(moment(nextBillDate).date())
    addonDescription = (
      <p>{`Your ${addons} will automatically renew on the ${renewalDate} of each month.`}</p>
    )
  }

  return (
    <div className="order-summary-plan-renewal">
      {renewalText}
      {addonDescription}
      <p> You can cancel any time.</p>
    </div>
  )
}

export default PlanRenewal
